import { render, staticRenderFns } from "./MyPageParent.vue?vue&type=template&id=622ec46c&scoped=true"
import script from "./MyPageParent.vue?vue&type=script&lang=ts"
export * from "./MyPageParent.vue?vue&type=script&lang=ts"
import style0 from "./MyPageParent.vue?vue&type=style&index=0&id=622ec46c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ec46c",
  null
  
)

export default component.exports